import React from 'react'
import ReinstantmentMembershipTaskListForm from '../../features/MembershipTaskList/ReinstantmentMembershipTaskListForm'

const ReinstatementMembershipTaskList = () => {
    return (<ReinstantmentMembershipTaskListForm />)
}

export default ReinstatementMembershipTaskList
